<div #zoomDiv class="jk-row-border">
  <h4 class="text-center text-blue-700">期貨下單</h4>
  <app-jkcombobox [styleDisplay]="'flex'" label="帳號" [(value)]="stktuSrv.newItem.TU002" [width]="'200px'"
  [items]="stkmbSrv.futureAccountList">
  </app-jkcombobox>
  <app-jkdatefield label="委託日期" [(value)]="date" [showClearButton]="true" (valueChange)="onDateValueChange($event)">
  </app-jkdatefield>
  <mat-tab-group #masterTabGroup (selectedTabChange)="onMasterTabChange($event)">
    <mat-tab #myTabGrid label="期貨下單">
      <div class="jk-row-border" style="width: 350px">
        <div class="flex">
        <app-jkautocomplete label="商品代號" [showClearButton]="true" valueExpr="id" displayExpr="name"
          [itemList]="stkmaSrv.futureList" [(value)]="stockno" >
        </app-jkautocomplete>
        <button class="jk-button-small" matSuffix mat-icon-button aria-label="open win" matTooltip="庫存"
        (click)="doOpenwinStock($event)">
        <mat-icon>more_vert</mat-icon>
        </button>
        </div>

        <div class="flex">
          <app-jkbuttongroup [title]="'盤別'" [items]="stktuSrv.tu012List" [(value)]="stktuSrv.tu012">
          </app-jkbuttongroup>
          <app-jkbuttongroup [title]="'當沖'" [items]="dayTradeList" [(value)]="stktuSrv.dayTrade">
          </app-jkbuttongroup>
        </div>
        <app-jkbuttongroup [title]="'倉別'" [items]="newCloseList" [(value)]="stktuSrv.newClose">
        </app-jkbuttongroup>
        <div class="flex">
          <app-jkbuttongroup [placeholder]="'條件'" [items]="tradeTypeList" [(value)]="stktuSrv.tradeType">
          </app-jkbuttongroup>
          <app-jkcheckboxYN label="暫存" [(valueYN)]="stktuSrv.newItem.TU020">
          </app-jkcheckboxYN>

        </div>
        <app-jkedit [visible]="true" [label]="'委託價'" [required]="true" [(value)]="stktuSrv.newItem.TU010" width="50"
          [styleDisplay]="'flex'">
        </app-jkedit>
        <app-jkbuttongroup [title]="''" [items]="priceTypeList" [(value)]="priceType">
        </app-jkbuttongroup>
        <div class="flex">
          <app-jkbuttongroup [placeholder]="'買賣'" [items]="buysaleList" [(value)]="stktuSrv.buysale">
          </app-jkbuttongroup>
          <app-jknumberedit [visible]="true" [label]="'口數'" [required]="true" [(value)]="stktuSrv.qty" width="60"
            [styleDisplay]="'flex'">
          </app-jknumberedit>
        </div>
        <div>現價:{{stklg.LG010}} 開盤價:{{stklg.LG007}} 最高價:{{stklg.LG008}} 最低價:{{stklg.LG009}} {{stklg.LG012 | date:'yyyy/MM/dd hh:mm:ss' }}</div>
        <div>預估保證金{{marginMoney}}</div>
        @if(stkmr.MR001!==''){
          <mat-divider></mat-divider>
        <div class="flex">
          商品代號:{{stkmr.MR001}} 買賣別:{{stkmr.MR006}} 未平倉:{{stkmr.MR007}} 平均成本:{{stkmr.MR009}} MR008:{{stkmr.MR008}}
          MR011:{{stkmr.MR011}}
        </div>
        }
        <button type="button" class="btn w-full"
          [class.btn-primary-red]="stktuSrv.buysale === '0'"
          [class.btn-primary-green]="stktuSrv.buysale === '1'"
          (click)="doSend()">{{stktuSrv.buysaleTitle}}</button>
        <div class="flex">
          <button class="btn" (click)="doTest()">測試</button>
          <button class="btn btn-secondary" (click)="doLoadRemember()">取前次</button>
        </div>
      </div>
    </mat-tab>
    <mat-tab #myDetailTab label="委託查詢">
      <div class="flex">
        <button class="btn" [class.btn-info]="true" (click)="doQuery()">查詢</button>
        <button class="btn" [class.btn-primary]="true" (click)="doChangePrice()">改價</button>
        <button class="btn" [class.btn-warning]="true" (click)="doChangeQty()">改量</button>
        <button class="btn" [class.btn-danger]="true" (click)="doDelete()">刪單</button>
      </div>
      <mat-divider></mat-divider>
      <div style="height: 400px;">
        <app-jkgridwin #jkgridwin (afterGridReady)="afterGridReady($event)">
        </app-jkgridwin>
      </div>
    </mat-tab>
    <mat-tab #myDetailTab label="回報查詢">
      <app-jkdatefield label="回報日期" [(value)]="date" [showClearButton]="true" (valueChange)="onDateValueChange($event)">
      </app-jkdatefield>
      <div class="flex">
        <button class="btn" [class.btn-info]="true" (click)="doQueryReply()">回報查詢</button>
        <button class="btn" [class.btn-primary]="true" (click)="doComfirm()">
          <mat-icon fontIcon="check_circle"></mat-icon>過帳
        </button>
      </div>
      <mat-divider></mat-divider>
      <div style="height: 400px;">
        <app-jkgridwin (afterGridReady)="afterGridReadyReply($event) ">
        </app-jkgridwin>
      </div>
    </mat-tab>
    <mat-tab #myQuote label="報價與未平倉">
      <div class="flex">
        <button class="btn" [class.btn-info]="true" (click)="doQueryBalance(2)">未平倉查詢</button>
      </div>
      <app-jkgridwin #stkmrGrid (afterGridReady)="afterGridReadyBalance($event)"(doubleClick)="balanceGridDoubleClick($event)">
      </app-jkgridwin>
    </mat-tab>
  </mat-tab-group>
</div>
